
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/back-to-top",
      function () {
        return require("private-next-pages/components/back-to-top.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/back-to-top"])
      });
    }
  